import React, { useState, useEffect } from 'react'
import { Text } from '@chakra-ui/core'
import { keyframes, css } from '@emotion/core'

const pulseKf = keyframes`
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.35; }
`

const pulseCss = css`
  animation: ${pulseKf} 1.4s ease-in-out infinite;
`

interface IProps {
  text: string
  color?: string
  fontSize?: string
  fontWeight?: any
}

const GeneratingText: React.FC<IProps> = ({ text, color = '#c0c0c0', fontSize = '14px', fontWeight = '400' }) => {
  const [dots, setDots] = useState(1)

  useEffect(() => {
    const t = setInterval(() => setDots((d) => (d >= 3 ? 1 : d + 1)), 500)
    return () => clearInterval(t)
  }, [])

  return (
    <Text fontSize={fontSize} fontWeight={fontWeight} color={color} css={pulseCss}>
      {text}
      <span aria-hidden="true" style={{ display: 'inline-block' }}>
        <span style={{ opacity: dots >= 1 ? 1 : 0 }}>.</span>
        <span style={{ opacity: dots >= 2 ? 1 : 0 }}>.</span>
        <span style={{ opacity: dots >= 3 ? 1 : 0 }}>.</span>
      </span>
    </Text>
  )
}

export default GeneratingText
